import { render } from "./HeroiconsOutlineExclamation.vue?vue&type=template&id=4beb75d7"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineExclamation.vue"]])

export default __exports__